/**
 * @ngdoc Directive
 * @name vrm-hr
 * @example
 *
 * <vrm-hr ng-model="help" ng-value="true" />
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmHr', vrmHr);

    /* @ngInject */
    function vrmHr($log, moment) {

        var definition = {
            restrict: 'E',
            template: require('@/angular/modules/vrm-components/hr/hr.template.html'),
            link: link,
            scope: {
                time: '=',
                realtime: '=',
                timezone: '=',
                offset: '=',
                alarm: '='
            },
        };

        return definition;

        function link($scope) {
            $scope.realtime = $scope.realtime && $scope.realtime;

            $scope.$watch('offset', function() {
                if ($scope.offset) {
                    $scope.formattedOffset = moment.utc(Math.abs($scope.offset) * 1000).format('H:mm');
                }
            });
        }
    }
})();
